export function arrayFromResponse(payload) {
  const queue = [payload];
  const visited = new Set();
  const arrayKeys = [
    "data",
    "Data",
    "items",
    "Items",
    "result",
    "Result",
    "value",
    "Value",
    "eventos",
    "Eventos",
    "$values",
  ];

  while (queue.length > 0) {
    const current = queue.shift();
    if (Array.isArray(current)) return current;
    if (!current || typeof current !== "object" || visited.has(current)) continue;

    visited.add(current);

    for (const key of arrayKeys) {
      if (Array.isArray(current[key])) return current[key];
    }

    for (const key of arrayKeys) {
      if (current[key] && typeof current[key] === "object") {
        queue.push(current[key]);
      }
    }
  }

  return [];
}
